import { interopDefault } from '~/router/utils'
import { smoothenRoutesScroll } from '~/utils/router'

export const auditShopsRoutes = smoothenRoutesScroll([
  {
    path: 'audits/shops',
    name: '__account_audits_shops',
    component: () =>
      interopDefault(
        import(
          '~/pages/account/audits/shops/index.vue' /* webpackChunkName: "pages-account-audits-shops-index.vue" */
        )
      )
  },
  {
    path: 'audits/shops/new',
    name: '__account_audits_shops_new',
    component: () =>
      interopDefault(
        import(
          '~/pages/account/audits/shops/new.vue' /* webpackChunkName: "pages-account-audits-shops-new.vue" */
        )
      ),
    meta: {
      noBackTopMenu: true
    }
  },
  {
    path: 'audits/shops/:shopId/edit',
    name: '__account_audits_shops_edit',
    component: () =>
      interopDefault(
        import(
          '~/pages/account/audits/shops/edit/index.vue' /* webpackChunkName: "pages-account-audits-shops-edit-index.vue" */
        )
      ),
    children: [
      {
        path: 'details',
        redirect: { name: '__account_audits_shops_edit' }
      },
      {
        path: 'auditors',
        name: '__account_audits_shops_edit_auditors',
        component: () =>
          interopDefault(
            import(
              '~/pages/account/audits/shops/edit/auditors/index.vue' /* webpackChunkName: "pages-account-audits-shops-edit-auditors-index.vue" */
            )
          )
      },
      {
        path: 'auditors/new',
        name: '__account_audits_shops_edit_auditors_new',
        component: () =>
          interopDefault(
            import(
              '~/pages/account/audits/shops/edit/auditors/new.vue' /* webpackChunkName: "pages-account-audits-shops-edit-auditors-new.vue" */
            )
          )
      },
      {
        path: 'auditors/:auditorId/edit',
        name: '__account_audits_shops_edit_auditors_edit',
        component: () =>
          interopDefault(
            import(
              '~/pages/account/audits/shops/edit/auditors/edit.vue' /* webpackChunkName: "pages-account-audits-shops-edit-auditors-edit.vue" */
            )
          )
      }
    ]
  }
])
